import React from 'react';
import Nailserice from '../assets/nailser.jpeg';
import glassglow from '../assets/glassglow.jpg';
import skintightening from '../assets/skintightening.jpg';
import acne from '../assets/acne.jpg';
import './Service.css';

const Skincaretreatment = () => {
  return (
    <>
   <div class="homepageimg">
        <img src={Nailserice} alt="Beauty Destination" class="full-screen-image bgimg" />
   </div>
<div class="d-flex justify-content-center pt-5">
  <h1 style={{ color: '#b37777', fontStyle: 'italic', fontFamily: "'TAN TWINKLE', cursive" }}>Skincare Treatments</h1>
</div>
   <div class="container pt-4">
    <div class="row align-items-center  animate-form1 servicecontainer">
        <div class="col-sm-6">
            <h1 class="service-header text-center">Glass Glow Treatment</h1>
            <p>
              Achieve radiant, flawless skin with our Glass Glow Treatment. Perfect for a luminous, youthful glow, 
              it reduces blemishes, fine lines, and provides deep hydration. Shine bright and feel confident!    
              </p>           
              <p class="service-price"><strong>Pricing:</strong> Starts from $XX</p>
        </div>
        <div class="col-sm-6">
            <img src={glassglow} alt="Nail Services" style={{width: "100%", height: "500px"}} />
        </div>
       
    </div>
    <div class="row align-items-center animate-form servicecontainer">
      
      <div class="col-sm-6">
          <img src={skintightening} alt="Nail Services" style={{width: "100%", height: "500px"}} />
      </div>
      <div class="col-sm-6">
        <h1 class="service-header text-center pt-2">Skin Tightening</h1>
        <p>
          Restore firmness and lift with our Skin Tightening Treatment. It reduces wrinkles, tightens loose skin, 
          and enhances your natural glow for a more youthful appearance. Feel confident and refreshed! 💫
         </p>
        <p class="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
  </div>
  <div class="row align-items-center animate-form1 servicecontainer">
    <div class="col-sm-6">
        <h1 class="service-header text-center">Active Acne Treatment</h1>
        <p>
          Say goodbye to stubborn breakouts with our Active Acne Treatment. Designed to clear blemishes, reduce redness, and prevent future acne, this 
          treatment restores healthy, clear skin. Achieve smoother, clearer skin and boost your confidence! 
          </p>
           <p class="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
    <div class="col-sm-6">
        <img src={acne} alt="Nail Services" style={{width: "100%", height: "500px"}} />
    </div>
   
</div>
</div>


    
    </>
  )
}
export default Skincaretreatment;